import React from 'react';
import Main from '../pages/Main/Main'
import Header from '../components/Header/Header'
import Copyright from '../components/Copyright/Copyright'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import TemplateCreatorPage from '../pages/Admin/SubModule/TemplateCreatorPage/TemplateCreatorPage';
import FieldsCreatorPage from '../pages/Admin/SubModule/FieldsCreatorPage/FieldsCreatorPage';
import SectionCreatorPage from '../pages/Admin/SubModule/SectionCreatorPage/SectionCreatorPage';
import AuthenticationPage from '../pages/AuthenticationPage/AuthenticationPage';
import ErrorPage from '../pages/ErrorPage/ErrorPage';
import UnauthorizedPage from '../pages/AuthenticationPage/UnauthorizedPage';
import ListPage from '../pages/ListPage/ListPage';
import RequiredAuth from './RequiredAuth';
import AdminRoute from './AdminRoute'
import { ROLES } from '../constants/roles';
import Version from '../components/Version/Version';
import PublicPDFPage from '../pages/ViewPDFPage/PublicPDFPage/PublicPDFPage';

const AppRouter = () => {
    return (
        <BrowserRouter basename="/">
            <Header />
            <Routes>
                {/* public page - shareable page */}
                <Route path="/public/forms/:type/:transID/:formID/:encryptedDate" element={<PublicPDFPage />} />

                <Route element={<RequiredAuth />}>
                    {/* User - Main */}
                    <Route path="/" element={<ListPage />} />
                    <Route path="/create" element={<Main />} />
                    <Route path="/create/postalcode/:postalCode" element={<Main />} />
                    <Route path="/edit/:transID" element={<Main />} />
                    <Route path="/upload/:transID" element={<Main />} />
                    {/* Create for AGENT */}
                    <Route path="/create/agent/:agentID" element={<Main />} />
                    <Route path="/create/agent/:agentID/postalcode/:postalCode" element={<Main />} />
                </Route>

                {/* Admin Route */}
                <Route element={<AdminRoute allowedRoles={[ROLES.HQ]} />}>

                    

                    {/* New */}
                    <Route path="/admin/forms/create" element={<TemplateCreatorPage />} />
                    {/* Edit */}
                    {/* Main Fields & Sections */}
                    <Route path="/admin/main/fields/edit/:formId" element={<FieldsCreatorPage />} />
                    <Route path="/admin/main/section/edit/:formId" element={<SectionCreatorPage />} />
                    {/* Form Fields & sections */}
                    <Route path="/admin/forms/edit/:formId" element={<TemplateCreatorPage />} />
                    <Route path="/admin/fields/edit/:formId" element={<FieldsCreatorPage />} />
                    <Route path="/admin/section/edit/:formId" element={<SectionCreatorPage />} />
                </Route>

                {/* with Authentication */}
                <Route path="/authentication/:id/" element={<AuthenticationPage />} />
                <Route path="/authentication/:id/:action" element={<AuthenticationPage />} />
                {/* <Route path="/authentication/:id/:action/postalcode/:postalCode" element={<AuthenticationPage />} />
                <Route path="/authentication/:id/:action/agent/:agentID" element={<AuthenticationPage />} />
                <Route path="/authentication/:id/:action/agent/:agentID/postalcode/:postalCode" element={<AuthenticationPage />} /> */}
                <Route path="/authentication/:id/:action/:transactionID" element={<AuthenticationPage />} />
                {/* for CREATE */}
                <Route path="/authentication/:id/:action/BDC/Sales/:propertyID" element={<AuthenticationPage />} />
                <Route path="/authentication/:id/:action/BDC/Sales/:propertyID/agent/:agentID" element={<AuthenticationPage />} />
                <Route path="/authentication/:id/:action/Agency/:type/postalcode/:postalCode/agent/:agentID/" element={<AuthenticationPage />} />

                <Route path="/UnauthorizedAccess" element={<UnauthorizedPage />} />
                <Route path="/error" element={<ErrorPage />} />
            </Routes>
            <Copyright />
            <Version />
        </BrowserRouter>
    );
}

export default AppRouter;